(async function () {
  const el = document.getElementById("trustooHeaderRating");
  if (!el) return;

  const WORKER_URL = "https://reviewstrustoo.calm-disk-819c.workers.dev/";

  try {
    const res = await fetch(WORKER_URL, { cache: "no-store" });
    const json = await res.json();

    if (!json || json.code !== 0 || !json.data) return;

    const rating = parseFloat(String(json.data.rating_value || "").replace(",", "."));
    const count = Number(json.data.review_count || 0);

    if (!Number.isFinite(rating) || rating <= 0) return;

    el.innerHTML = `
      <span class="trustoo-stars" aria-hidden="true">
        ${renderStars(rating)}
      </span>
      <strong>${rating.toFixed(1)}</strong>
      <span class="trustoo-muted">(${count})</span>
    `;
  } catch (e) {
    // stil falen
  }

  function renderStars(rating) {
    const r = Math.max(0, Math.min(5, rating));
    const full = Math.floor(r);
    const half = (r - full) >= 0.5 ? 1 : 0;
    const empty = 5 - full - half;

    let html = "";
    for (let i = 0; i < full; i++) html += star(true);
    if (half) html += halfStar();
    for (let i = 0; i < empty; i++) html += star(false);
    return html;
  }

  function star(filled) {
    return `
      <span class="trustoo-star">
        <svg viewBox="0 0 24 24" width="16" height="16">
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22
               12 18.77 5.82 22 7 14.14l-5-4.87
               6.91-1.01z"
            fill="${filled ? "currentColor" : "none"}"
            stroke="currentColor"
            stroke-width="1"/>
        </svg>
      </span>`;
  }

  function halfStar() {
    const id = "halfGrad_" + Math.random().toString(16).slice(2);

    return `
      <span class="trustoo-star">
        <svg viewBox="0 0 24 24" width="16" height="16">
          <defs>
            <linearGradient id="${id}">
              <stop offset="50%" stop-color="currentColor"></stop>
              <stop offset="50%" stop-color="transparent"></stop>
            </linearGradient>
          </defs>
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22
               12 18.77 5.82 22 7 14.14l-5-4.87
               6.91-1.01z"
            fill="url(#${id})"
            stroke="currentColor"
            stroke-width="1"/>
        </svg>
      </span>`;
  }
})();
